import { action } from 'satcheljs';
import { Calendar } from 'owa-calendar-cache';

export const onBeforeCalendarDelete = action('onBeforeCalendarDelete', (calendar: Calendar) => ({
    calendar,
}));
